<template>
  <div class="content">
    <div class="title">保障协议</div>
    <div class="sub-title">保障内容</div>
    <p class="txt">科三保/科二保包含以下内容：</p>
    <p class="txt">1. 科三/科二不过，补偿对应套餐部分费用。</p>
    <p class="txt">2. 科四理论不过，单科一次性补偿50元。</p>
    <div class="sub-title">保障说明</div>
    <p class="txt">1. 本保障仅支持报名C1、C2的学员（18-65周岁）购买，在每个学车周期内限购1份。</p>
    <p class="txt">2. 自保障生效当日起，用完套餐内学时，科二/科三考试不过，补偿对应套餐价格的部分费用，具体报销比例请参照购买的套餐为准。</p>
    <p class="txt">3. 科四理论考试不过，即可获得50元的一次性补偿，科四理论保过卡需在车轮驾考通APP内按要求答题后激活。</p>
    <p class="txt">4. 学员申请报销时，需按要求提供相关材料，否则无法完成报销。</p>
    <p class="txt">5. 自保障生效到最近一次科目三考试则本次保障责任结束，保障期最多12个月为限；科四保障有效期为，科四保过卡激活到最近一次科四考试则本次保障责任结束。</p>
    <p class="txt">6. 除法律法规规定的情形外，保障生效后无法退换。</p>
    <p class="txt">7. 因被保障人未及时参加驾驶培训机构的培训而导致超过学习时效的，不予报销。</p>
    <div class="sub-title">客户服务</div>
    <p class="txt">保障期间，车轮公司将提供专属客户服务，包括：</p>
    <p class="txt">1. 产品咨询</p>
    <p class="txt">2. 报销指导</p>
    <p class="txt">3. 售后服务</p>
    <div class="sub-title">报销流程</div>
    <p class="txt">1. 科三/科二报销流程：在对应保障的产品主页，点击“查询&理赔”进入自助申请报销流程。</p>
    <p class="txt">2. 科四报销流程：在车轮驾考通APP-理论保过卡，提交资料后进入自助报销流程。</p>
    <div class="sub-title">补充说明</div>
    <p class="txt">为优化被保人报销体验，确认本协议则代表被保人在申请报销过程中需要签订相关材料时，同意并授权我单位代为签字。</p>
  </div>
</template>
<script>
import _wx from '../../../static/js/chelun-wx-1.1.js'
import _kjz from '../../../static/js/chelun-kjz.js'
export default {
  created() {
    window['CHELUN_SHOW_OPTION_MENU'] = 0
    _wx.hideMenus(["menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:facebook", "menuItem:share:QZone"])
  }
}
</script>
<style lang="scss" scoped>
.content {
  line-height: 1;
  text-align: 0;
  padding: .3rem;
}
.title {
  text-align: center;
  font-size: .36rem;
  font-weight: 600;
  line-height: .8rem;
}
.sub-title {
  margin-top: .36rem;
  margin-bottom: .2rem;
  font-size: .32rem;
  font-weight: 500;
  &::before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: .1rem;
    height: .1rem;
    border-radius: .05rem;
    margin-right: .2rem;
    background: #000;
  }
}
.txt {
  line-height: 1.5;
  font-size: .3rem;
  text-indent: 1em;
}
</style>



// WEBPACK FOOTER //
// src/pages/productDetail/protocol.vue